import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { Logo } from "./Logo";
import { scrollToId, whatsappLink, INSTAGRAM_URL } from "../lib/site";

const LINKS = [["servicos", "Serviços"], ["projetos", "Projetos"], ["processo", "Processo"], ["contato", "Contato"]];

export const Nav = ({ onBrief }) => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const f = () => setScrolled(window.scrollY > 40);
    f();
    window.addEventListener("scroll", f, { passive: true });
    return () => window.removeEventListener("scroll", f);
  }, []);
  const go = (id) => { setOpen(false); setTimeout(() => scrollToId(id), 50); };

  return (
    <>
      <header className={`fixed top-0 inset-x-0 z-50 transition-[background-color,backdrop-filter,border-color] duration-500 border-b ${scrolled ? "bg-[#050505]/70 backdrop-blur-xl border-white/5" : "border-transparent"}`}>
        <nav className="mx-auto max-w-[1440px] h-16 lg:h-20 px-5 sm:px-8 lg:px-12 flex items-center justify-between">
          <a href="#top" onClick={(e) => { e.preventDefault(); window.__lenis ? window.__lenis.scrollTo(0) : window.scrollTo({ top: 0, behavior: "smooth" }); }} data-testid="nav-logo" aria-label="NEXUS — início">
            <Logo intro className="text-[1.6rem] lg:text-[2rem]" />
          </a>
          <ul className="hidden lg:flex items-center gap-10">
            {LINKS.map(([id, t]) => (
              <li key={id}>
                <button onClick={() => go(id)} data-testid={`nav-link-${id}`} className="group relative text-sm text-[#F5F3EE]/80 hover:text-[#F5F3EE] transition-colors">
                  {t}
                  <span className="absolute -bottom-1 left-0 h-px w-full origin-left scale-x-0 bg-[#D4AF5A] transition-transform duration-500 group-hover:scale-x-100" />
                </button>
              </li>
            ))}
          </ul>
          <div className="flex items-center gap-2">
            <button onClick={onBrief} data-testid="nav-budget-btn" className="btn-ghost rounded-full h-11 px-5 text-[13px] font-medium tracking-wide text-[#F5F3EE]">
              Orçamento
            </button>
            <button onClick={() => setOpen(true)} data-testid="nav-menu-open" aria-label="Abrir menu" className="lg:hidden grid place-items-center h-11 w-11 rounded-full bg-white/5 border border-white/10">
              <Menu size={18} />
            </button>
          </div>
        </nav>
      </header>
      <AnimatePresence>
        {open && (
          <motion.div className="fixed inset-0 z-[70] lg:hidden" initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
            <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={() => setOpen(false)} />
            <motion.div
              data-testid="mobile-menu"
              className="absolute bottom-0 inset-x-0 rounded-t-[28px] bg-[#111111] border-t border-white/10 px-6 pt-5 pb-[max(1.5rem,env(safe-area-inset-bottom))]"
              initial={{ y: "100%" }} animate={{ y: 0 }} exit={{ y: "100%" }} transition={{ type: "spring", damping: 30, stiffness: 300 }}
            >
              <div className="flex items-center justify-between mb-4">
                <span className="label">Menu</span>
                <button onClick={() => setOpen(false)} data-testid="nav-menu-close" aria-label="Fechar menu" className="grid place-items-center h-11 w-11 rounded-full bg-white/5"><X size={18} /></button>
              </div>
              <ul>
                {LINKS.map(([id, t], i) => (
                  <li key={id} className="border-b border-white/5">
                    <button onClick={() => go(id)} data-testid={`mobile-link-${id}`} className="w-full flex items-center justify-between py-4 font-display text-2xl font-semibold">
                      {t}<span className="font-mono text-xs text-gold">0{i + 1}</span>
                    </button>
                  </li>
                ))}
              </ul>
              <button onClick={() => { setOpen(false); onBrief(); }} data-testid="mobile-menu-brief" className="btn-gold mt-6 w-full h-14 rounded-full font-semibold text-sm tracking-[0.08em] uppercase flex items-center justify-center gap-2">
                Solicitar um projeto <ArrowUpRight size={16} />
              </button>
              <div className="mt-4 grid grid-cols-2 gap-3 text-sm">
                <a href={whatsappLink()} target="_blank" rel="noopener noreferrer" data-testid="mobile-menu-whatsapp" className="btn-ghost h-12 rounded-full grid place-items-center">WhatsApp</a>
                <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" data-testid="mobile-menu-instagram" className="btn-ghost h-12 rounded-full grid place-items-center">Instagram</a>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};
